var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramStandardVehicle48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Small./StandardVehicle48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 14.000000)",
    fillRule: "nonzero",
    id: "pictogramStandardVehicle48",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,8 L34,8 C36.2,8 38,9.8 38,12 L38,17 L4,17 C1.8,17 0,15.2 0,13 L0,8 Z",
    id: "Rectangle-38",
    stroke: "#4F4D4C",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,17 C33,19.1 31.3,20.8 29.3,20.8 C27.3,20.8 25.6,19.1 25.6,17 C25.6,14.9 27.3,13.2 29.3,13.2 C31.4,13.2 33,14.9 33,17 Z",
    id: "Stroke-7",
    stroke: "#4F4C4D",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6,17 C11.6,19.1 9.9,20.8 7.9,20.8 C5.9,20.8 4.2,19.1 4.2,17 C4.2,14.9 5.9,13.2 7.9,13.2 C10,13.2 11.6,14.9 11.6,17 Z",
    id: "Stroke-11",
    stroke: "#4F4C4D",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-15",
    stroke: "#4F4C4D",
    fill: "#FFFFFF",
    points: "9.2 0 22.1 0 28.7 8 2.7 8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramStandardVehicle48);
export default __webpack_public_path__ + "static/media/pictogramStandardVehicle48.1a3384accd2614426d955f9099df1df2.svg";
export { ForwardRef as ReactComponent };